import {BaseService, Body, GET, Headers, PATCH, Path, POST, Response} from "ts-retrofit";
import {ACCEPT_JSON} from "../config";
import {ToData, ToListedResponse} from "../rest-api-hydratator-decorators";
import {User} from "../../../models/user";
import {UserData} from '../../../models/user-data';
import {ListedResponse} from '../../../models/hydratator/listed-response';
import {FilterUsersRequest} from '../../../models/requests/filter-users.request';

const base = 'users';

export class UsersApiService extends BaseService {
  // @POST(`/${base}/theme/{themeId}`)
  // @Headers({
  //   ...ACCEPT_JSON
  // })
  // async updateTheme(@Path('themeId') themeId: number): Promise<Response> {
  //   return <Response>{};
  // }

  @GET(`/${base}/me`)
  @Headers({...ACCEPT_JSON})
  @ToData(User)
  async getCurrentUser(): Promise<Response<User>> {
    return <Response>{};
  }

  @PATCH(`/${base}/me`)
  @Headers({
    ...ACCEPT_JSON
  })
  async updateCurrentUser(@Body saveUserRequest: UpdateUserRequest): Promise<Response<User>> {
    return <Response>{};
  }

  @GET(`/${base}`)
  @Headers({
    ...ACCEPT_JSON
  })
  @ToData(User)
  async getAllUsers(): Promise<Response<User[]>> {
    return <Response>{};
  }


  @POST(`/${base}/recover`)
  @Headers({
    ...ACCEPT_JSON
  })
  async recoveryPassword(
    @Body request: {email: string},
  ) {
    return <Response<UserData>>{};
  }

  @PATCH(`/${base}/reset`)
  @Headers({
    ...ACCEPT_JSON
  })
  async resetPassword(
    @Body request: {userId: number, code: string, password: string},
  ) {
    return <Response<UserData>>{};
  }

  @POST(`/${base}/change-password`)
  @Headers({...ACCEPT_JSON})
  async changePassword(
    @Body request: ChangePasswordRequest,
  ): Promise<Response<boolean>> {
    return <Response>{};
  }

  @POST(`/${base}/search`)
  @Headers({...ACCEPT_JSON})
  @ToListedResponse(User)
  async filter(@Body request: FilterUsersRequest): Promise<Response<ListedResponse<User>>> {
    return <Response>{};
  }

  @GET(`/${base}/{id}`)
  @Headers({...ACCEPT_JSON})
  @ToData(User)
  async getUserById(@Path('id') id: number): Promise<Response<User>> {
    return <Response>{};
  }

  @POST(`/${base}`)
  @Headers({...ACCEPT_JSON})
  @ToData(User)
  async save(@Body user: User): Promise<Response<User>> {
    return <Response>{};
  }
}

export interface UpdateUserRequest {
  name: string;
  surname: string;
  password: string;
  email: string;
  // base64FileContent?: string | null;
  // filename?: string | null;
}

export interface ChangePasswordRequest {
  CurrentPassword: string;
  NewPassword: string;
}
